// services/mySuggestions.service.js
//
// ⚠️ USE `apiClient`. NOT `jsonApiClient` — the same trap, for the same reason, as
// referral.service.js beside it.
//
// `GET /my-suggestions` is plain JSON in the referral list's shape (BE→FE brief
// 2026-10-02-suggestion-reward): `{ data: [{ id, product, suggestion,
// helpedMembers, earnedCents, awaitingCents }], meta: {...} }`. It is not a
// JSON:API resource document, so routed through jsonApiClient jsona would flatten
// each row down to little more than its `id` — and it would NOT throw, leaving a
// 200 in the network tab and an empty screen.
//
// `suggestion` is the SAME object an order line's `supplierSuggestion` carries,
// so utils/supplierSuggestion.js reads it unchanged.
//
// Approved seller members only — 401 unauthenticated, 403
// `errors[0].code = 'not-a-member'` for anyone else (the /suppliers gate).
import { apiClient } from '@/httpConfig/config/axios';

export const mySuggestionsService = {
  /**
   * Her suggestions, newest first, at most 100.
   *
   * @returns {Promise<import('axios').AxiosResponse>} raw body: `{ data: [...], meta: {…} }`
   */
  list: () => apiClient.get('/my-suggestions'),
};
